export default function ErrorMessage({value}: {value: any}) {
  return <div className="text-red-600 text-sm">{value ?? <>&nbsp;</>}</div>
}
